import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_URL } from '../../api/ApiSettings';
import * as errorSlice from '../error/errorSlice';

// Define your initial state
const initialState = {
  captchaSiteKey: '',
  validationResult: false,
};

// Create the async thunk to fetch captcha site key
export const getCaptchaSiteKey = createAsyncThunk('captcha/getCaptchaSiteKey', async (_, { rejectWithValue,dispatch }) => {
  try {
    const response = await fetch(`${API_URL}util/getSettingValue?settingName=CaptchaSiteKey`);
    const result = await response.json();
    if (response.status === 200) {
      return result;
    } else {
      console.error("Błąd pobierania danych");
      dispatch(errorSlice.setError("Błąd pobierania danych"))
      return rejectWithValue("Błąd pobierania danych");
    }
  } catch (error) {
    dispatch(errorSlice.setError("Błąd pobierania danych"))
    return rejectWithValue("Błąd pobierania danych");
  }
});


// Create the async thunk to validate captcha
export const validateCaptcha = createAsyncThunk(
  'captcha/validateCaptcha',
  async (captchaResponse, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}captcha/getCaptchaValidateValue`, {
        method: "POST", // ✅ zmiana na POST
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          captchaResponse: captchaResponse // ✅ wysyłamy w body
        })
      });

      const result = await response.json();

      if (response.status === 200) {
        return result;
      } else {
        console.error("Błąd pobierania danych");
        return rejectWithValue("Błąd pobierania danych");
      }

    } catch (error) {
      console.error(error);
      return rejectWithValue("Błąd pobierania danych");
    }
  }
);


// Create the captcha slice
const captchaSlice = createSlice({
  name: 'captcha',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Reducer for getCaptchaSiteKey
    
    builder
      .addCase(getCaptchaSiteKey.fulfilled, (state, action) => {
        state.captchaSiteKey = action.payload;
      })
      .addCase(getCaptchaSiteKey.rejected, (state, action) => {
        console.error("Error during getCaptchaSiteKey:", action.payload);
        errorSlice.setError(action.payload);
      })
      .addCase(validateCaptcha.fulfilled, (state, action) => {
        state.validationResult = action.payload;
      })
      .addCase(validateCaptcha.rejected, (state, action) => {
        console.error("Error during validateCaptcha:", action.payload);
        errorSlice.setError(action.payload);
      });
  },

});

export default captchaSlice.reducer;